import { gql } from "urql";
export const GetPatientCountQuery = gql `
    query GetPatientCount($search: String) {
        patients {
            patientCount(search: $search)
        }
    }
`;
export const GetPatientsQuery = gql `
    query GetPatients($search: String, $offset: Int) {
        patients {
            patients(search: $search, offset: $offset) {
                patientId
                caregiverId
                firstName
                lastName
                dateOfBirth
                preferredLanguages
                daysAvailable
                timeAvailable
                postalCode
                isActive
                createdAt
                postalCodeInfo {
                    city
                    stateId
                }
            }
        }
    }
`;
export const GetPatientQuery = gql `
    query GetPatient($patientId: String!) {
        patients {
            patient(patientId: $patientId) {
                patientId
                caregiverId
                firstName
                lastName
                dateOfBirth
                preferredLanguages
                daysAvailable
                timeAvailable
                postalCode
                gradeLevel
                isActive
                createdAt
                caregiver {
                    userId
                    firstName
                    lastName
                }
                providers {
                    userId
                    firstName
                    lastName
                    imageUrl
                }
                postalCodeInfo {
                    city
                    stateId
                }
                conditionList {
                    label
                    value
                }
                insuranceList {
                    label
                    value
                }
                therapyCategoryList {
                    label
                    value
                }
                therapySubCategoryList {
                    label
                    value
                }
            }
        }
    }
`;
